export class LoadingService {
    constructor($uibModal) {
        this.$uibModal = $uibModal;
    }

    open(message) {
        return this.$uibModal.open({
            templateUrl: 'app/shared/loading.html',
            controller: 'LoadingController',
            controllerAs: 'vm',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                'message': function() {
                    return message;
                }
            }
        });
    }

    close(instance) {
        instance.rendered.then(function () {
            instance.close();
        });
    }
}

LoadingService.$inject = ['$uibModal'];